import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const DepartmentList = Loadable(
  lazy(() => import("features/department/components/List"))
);
const DepartmentPage = Loadable(
  lazy(() => import("features/department/components/Page"))
);


const routes = {
  path: "department",
  children: [
    { path: "", element: <DepartmentList /> },
    { path: "add", element: <DepartmentPage /> },
    { path: "edit/:departmentId?", element: <DepartmentPage /> },
  ],
};

export default routes;
